import React from 'react'

const Trainers = () => {
  return (
 <>
   <div class="section" id="trainer">
      <h2 class="primary mb">Our Professional Trainers</h2>
      <div class="container flex">
        <div class="trainer">
          <img
            src="https://i.imgur.com/F35Rs50.jpeg"
            alt=""
            style={{width:'300px'}}
          />
          <h3 class="secondary mb">Carl</h3>
        

      
        </div>

        <div class="trainer">
          <img
            src="https://i.imgur.com/jI7Jn9t.jpegg"
            alt=""
            style={{width:'300px'}}
          />
          <h3 class="secondary mb">Ghady</h3>
        

         
        </div>

        <div class="trainer">
          <img
            src="https://i.imgur.com/fKrzS6M.jpeg"
            alt=""
            style={{width:'300px'}}
          />
          <h3 class="secondary mb">Ralph</h3>
        

       
        </div>
      </div>
    </div>

 </>
  )
}

export default Trainers